/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_Or_Hide_TimelineInputs */



/**
* | output |
* | --- |
* | "Show or hide timeline" |
*
* @param {Show_Or_Hide_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const show_or_hide_timeline = /** @type {((inputs?: Show_Or_Hide_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_Or_Hide_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher ou masquer la ligne de temps")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste ein- oder ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra o nascondi la cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать или скрыть временную шкалу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar u ocultar la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示或隐藏时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインを表示または非表示にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन दिखाएं या छिपाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar ou ocultar a linha do tempo")
	return /** @type {LocalizedString} */ ("Show or hide timeline")
});